import { c as _c } from "react/compiler-runtime";
// Third Party
import * as React from 'react';
import cx from 'classnames';

// Utils
import { useRouter } from 'next/navigation';
import { routes } from '@routes';
import { useSession } from '@lib/auth/client';
import { useToggleFavorite } from './use-toggle-favorite';
export type IFavoriteButtonProps = {
  listingID: string;
  listingIsFavorited: boolean;
  onFavoritedSuccess?: (isFavorited: boolean) => void;
  size?: 'sm' | 'md' | 'lg';
};
export const FavoriteButton: React.FC<IFavoriteButtonProps> = t0 => {
  const $ = _c(22);
  const {
    listingID,
    listingIsFavorited,
    onFavoritedSuccess,
    size
  } = t0;
  const toggleFavorite = useToggleFavorite();
  const {
    data: session,
    status
  } = useSession();
  const router = useRouter();
  const [favLoading, setFavLoading] = React.useState(false);
  let t1;
  if ($[0] !== listingIsFavorited || $[1] !== onFavoritedSuccess || $[2] !== router || $[3] !== session?.user || $[4] !== toggleFavorite) {
    t1 = async function handleFav(listingId) {
      if (session?.user == null) {
        router.push(routes.login, {
          scroll: false
        });
        return;
      }
      setFavLoading(true);
      const isNowFavorited = await toggleFavorite(listingId, listingIsFavorited);
      setFavLoading(false);
      if (isNowFavorited !== null) {
        onFavoritedSuccess?.(isNowFavorited);
      }
    };
    $[0] = listingIsFavorited;
    $[1] = onFavoritedSuccess;
    $[2] = router;
    $[3] = session?.user;
    $[4] = toggleFavorite;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const handleFav = t1;
  const isSessionPending = status === "loading";
  const t2 = favLoading || isSessionPending;
  let t3;
  if ($[6] !== handleFav || $[7] !== listingID) {
    t3 = () => handleFav(listingID);
    $[6] = handleFav;
    $[7] = listingID;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const t4 = listingIsFavorited ? "Remove from favorites" : "Add to favorites";
  const t5 = size === "lg" ? "p-2" : size === "md" ? "p-[14px]" : "p-4";
  let t6;
  if ($[9] !== t5) {
    t6 = cx("rounded-full", "focus-visible:outline", "focus-visible:outline-2", "focus-visible:outline-offset-2", "focus-visible:outline-primary-main", "transition-transform", "duration-200", "hover:scale-110", "active:scale-95", t5);
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== listingIsFavorited || $[12] !== size) {
    t7 = listingIsFavorited ? <img src="/assets/svg/favHeartFilled.svg" alt="Favorited Vacation Rental" aria-hidden="true" className={cx(size === "lg" ? "w-8 h-8" : size === "md" ? "w-5 h-5" : "w-4 h-4")} /> : <img src="/assets/svg/favHeart.svg" alt="Favorite Vacation Rental" aria-hidden="true" className={cx(size === "lg" ? "w-8 h-8" : size === "md" ? "w-5 h-5" : "w-4 h-4")} />;
    $[11] = listingIsFavorited;
    $[12] = size;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== isSessionPending || $[15] !== listingIsFavorited || $[16] !== t2 || $[17] !== t3 || $[18] !== t4 || $[19] !== t6 || $[20] !== t7) {
    t8 = <div><button disabled={t2} aria-busy={isSessionPending} onClick={t3} aria-pressed={listingIsFavorited} aria-label={t4} className={t6}>{t7}</button></div>;
    $[14] = isSessionPending;
    $[15] = listingIsFavorited;
    $[16] = t2;
    $[17] = t3;
    $[18] = t4;
    $[19] = t6;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  return t8;
};